// Legal pages content (DE/EN/FR). Own GDPR-compliant boilerplate + factual company data.

export const LEGAL_SLUGS = {
  impressum: "/impressum",
  datenschutz: "/datenschutz",
  agb: "/agb",
  einlagensicherung: "/einlagensicherung",
  cookies: "/cookies",
};

const legal = {
  de: {
    updatedLabel: "Stand: Juli 2025",
    order: ["impressum", "datenschutz", "agb", "einlagensicherung", "cookies"],
    labels: {
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      agb: "AGB",
      einlagensicherung: "Einlagensicherung",
      cookies: "Cookies",
    },
    impressum: {
      title: "Impressum",
      blocks: [
        { h: "Angaben gemäß Impressumspflicht", p: ["Barlow Consultants SL", "Hauptsitz: Luxembourg", "Niederlassung Deutschland: Kurfürstendamm 30, 10719 Berlin, Deutschland"] },
        { h: "Handelsregister", p: ["Eingetragen im Registro Mercantil de Murcia", "Registernummer: MU-114516"] },
        { h: "Vertretungsberechtigter Geschäftsführer", p: ["Francesco Vigna"] },
        { h: "Kontakt", p: ["Telefon: +49 30 8268 8142", "E-Mail: info@barlowconsultants.com"] },
        { h: "Verantwortlich für den Inhalt", p: ["Francesco Vigna, Anschrift wie oben."] },
        { h: "Haftung für Inhalte", p: ["Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen."] },
      ],
    },
    datenschutz: {
      title: "Datenschutzerklärung",
      blocks: [
        { p: ["Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Nachfolgend informieren wir Sie über die Verarbeitung Ihrer Daten gemäß der Datenschutz-Grundverordnung (DSGVO)."] },
        { h: "Verantwortlicher", p: ["Barlow Consultants SL, Luxembourg – Niederlassung Berlin, Kurfürstendamm 30, 10719 Berlin", "E-Mail: info@barlowconsultants.com", "Datenschutz-Kontakt: datenschutz@barlowconsultants.com"] },
        { h: "Welche Daten wir verarbeiten", list: ["Bestandsdaten (z. B. Name)", "Kontaktdaten (z. B. E-Mail-Adresse, Telefonnummer)", "Nutzungsdaten Ihres Kundenkontos"] },
        { h: "Zwecke der Verarbeitung", p: ["Wir verarbeiten Ihre Daten zur Bereitstellung des Kundenportals, zur Bearbeitung von Anfragen sowie zur Erfüllung vertraglicher und gesetzlicher Pflichten."] },
        { h: "Rechtsgrundlagen", p: ["Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 DSGVO (Einwilligung, Vertragserfüllung sowie berechtigtes Interesse)."] },
        { h: "Ihre Rechte", list: ["Auskunft, Berichtigung und Löschung", "Einschränkung der Verarbeitung", "Datenübertragbarkeit", "Widerspruch sowie Widerruf einer Einwilligung", "Beschwerde bei einer Aufsichtsbehörde"] },
        { h: "Speicherdauer", p: ["Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke oder gesetzliche Aufbewahrungsfristen erforderlich ist."] },
      ],
    },
    agb: {
      title: "Allgemeine Geschäftsbedingungen",
      blocks: [
        { h: "1. Geltungsbereich", p: ["Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Website und der Dienstleistungen der Barlow Consultants SL."] },
        { h: "2. Leistungen", p: ["Barlow Consultants SL vermittelt Festgeldanlagen und bietet Vermögensberatung an. Die konkreten Konditionen ergeben sich aus dem jeweiligen Einzelvertrag."] },
        { h: "3. Konto & Registrierung", p: ["Für die Nutzung des Kundenportals ist eine Registrierung erforderlich. Sie sind für die Vertraulichkeit Ihrer Zugangsdaten verantwortlich."] },
        { h: "4. Konditionen & Rendite", p: ["Angegebene Zinssätze gelten für die jeweils gewählte Laufzeit. Renditeangaben zu Vermögensverwaltungsstrategien sind Zielwerte und stellen keine Garantie dar."] },
        { h: "5. Gebühren", p: ["Kontoeröffnung, Einzahlung und Kontoführung sind kostenfrei. Es fallen keine versteckten Gebühren an."] },
        { h: "6. Haftung", p: ["Für Schäden haften wir nur bei Vorsatz und grober Fahrlässigkeit, soweit gesetzlich zulässig."] },
        { h: "7. Anwendbares Recht", p: ["Es gilt das Recht des Großherzogtums Luxemburg, soweit gesetzlich zulässig."] },
      ],
    },
    einlagensicherung: {
      title: "Einlagensicherung",
      blocks: [
        { p: ["Ihre Einlagen sind gleich doppelt geschützt: durch die gesetzliche europäische Einlagensicherung und zusätzlich durch die getrennte Verwahrung auf einem Treuhandkonto."] },
        { h: "Gesetzliche Einlagensicherung (FGDL)", p: ["Die verwahrten Gelder unterliegen dem gesetzlichen Einlagensicherungssystem Luxemburgs (FGDL – Fonds de garantie des dépôts Luxembourg). Gemäß EU-Richtlinie 2014/49/EU sind Einlagen je Einleger und Institut bis zu 100.000 € abgesichert."] },
        { h: "Verwahrung", p: ["Die Gelder werden bei der Banking Circle S.A. in Luxemburg verwahrt."] },
        { h: "Zusätzlicher Treuhandschutz", p: ["Ergänzend werden Kundengelder auf einem separaten Treuhandkonto verwahrt – strikt getrennt vom Vermögen der Barlow Consultants SL."] },
      ],
    },
    cookies: {
      title: "Cookie-Richtlinie",
      blocks: [
        { p: ["Wir verwenden Cookies, um den Betrieb der Website sicherzustellen und Ihr Nutzungserlebnis zu verbessern."] },
        { h: "Notwendige Cookies", p: ["Diese Cookies sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden."] },
        { h: "Optionale Cookies", p: ["Mit Ihrer Einwilligung setzen wir optionale Cookies ein, um die Website zu verbessern."] },
        { h: "Verwaltung Ihrer Einstellungen", p: ["Sie können Ihre Cookie-Einwilligung jederzeit über den Cookie-Hinweis anpassen oder Cookies in Ihrem Browser löschen."] },
      ],
    },
  },

  en: {
    updatedLabel: "Last updated: July 2025",
    order: ["impressum", "datenschutz", "agb", "einlagensicherung", "cookies"],
    labels: {
      impressum: "Imprint",
      datenschutz: "Privacy",
      agb: "Terms",
      einlagensicherung: "Deposit protection",
      cookies: "Cookies",
    },
    impressum: {
      title: "Imprint",
      blocks: [
        { h: "Company information", p: ["Barlow Consultants SL", "Head office: Luxembourg", "Germany office: Kurfürstendamm 30, 10719 Berlin, Germany"] },
        { h: "Commercial register", p: ["Registered at the Registro Mercantil de Murcia", "Registration number: MU-114516"] },
        { h: "Authorised managing director", p: ["Francesco Vigna"] },
        { h: "Contact", p: ["Phone: +49 30 8268 8142", "Email: info@barlowconsultants.com"] },
        { h: "Responsible for content", p: ["Francesco Vigna, address as above."] },
        { h: "Liability for content", p: ["The content of these pages was created with the greatest care. However, we cannot guarantee the accuracy, completeness or timeliness of the content."] },
      ],
    },
    datenschutz: {
      title: "Privacy Policy",
      blocks: [
        { p: ["The protection of your personal data is important to us. Below we inform you about the processing of your data in accordance with the General Data Protection Regulation (GDPR)."] },
        { h: "Controller", p: ["Barlow Consultants SL, Luxembourg – Berlin office, Kurfürstendamm 30, 10719 Berlin", "Email: info@barlowconsultants.com", "Data protection contact: datenschutz@barlowconsultants.com"] },
        { h: "Data we process", list: ["Master data (e.g. name)", "Contact data (e.g. email address, phone number)", "Usage data of your client account"] },
        { h: "Purposes of processing", p: ["We process your data to provide the client portal, to handle enquiries and to fulfil contractual and legal obligations."] },
        { h: "Legal bases", p: ["Processing is based on Art. 6(1) GDPR (consent, performance of a contract and legitimate interest)."] },
        { h: "Your rights", list: ["Access, rectification and erasure", "Restriction of processing", "Data portability", "Objection and withdrawal of consent", "Complaint to a supervisory authority"] },
        { h: "Storage period", p: ["We store personal data only for as long as necessary for the stated purposes or required by statutory retention periods."] },
      ],
    },
    agb: {
      title: "Terms & Conditions",
      blocks: [
        { h: "1. Scope", p: ["These terms and conditions apply to the use of the website and the services of Barlow Consultants SL."] },
        { h: "2. Services", p: ["Barlow Consultants SL arranges fixed-deposit investments and offers wealth advisory. The specific conditions result from the respective individual contract."] },
        { h: "3. Account & registration", p: ["Registration is required to use the client portal. You are responsible for the confidentiality of your credentials."] },
        { h: "4. Conditions & returns", p: ["Stated interest rates apply for the chosen term. Return figures for wealth-management strategies are target values and do not constitute a guarantee."] },
        { h: "5. Fees", p: ["Account opening, deposits and account management are free of charge. There are no hidden fees."] },
        { h: "6. Liability", p: ["We are liable for damages only in cases of intent and gross negligence, to the extent permitted by law."] },
        { h: "7. Applicable law", p: ["The law of the Grand Duchy of Luxembourg applies, to the extent permitted by law."] },
      ],
    },
    einlagensicherung: {
      title: "Deposit Protection",
      blocks: [
        { p: ["Your deposits are protected twice: by the statutory European deposit guarantee and additionally by separate custody in a trust account."] },
        { h: "Statutory deposit guarantee (FGDL)", p: ["The funds held are subject to Luxembourg's statutory deposit guarantee scheme (FGDL – Fonds de garantie des dépôts Luxembourg). In accordance with EU Directive 2014/49/EU, deposits are protected up to €100,000 per depositor and institution."] },
        { h: "Custody", p: ["The funds are held at Banking Circle S.A. in Luxembourg."] },
        { h: "Additional trust protection", p: ["In addition, client funds are held in a separate trust account – strictly separated from the assets of Barlow Consultants SL."] },
      ],
    },
    cookies: {
      title: "Cookie Policy",
      blocks: [
        { p: ["We use cookies to ensure the operation of the website and to improve your experience."] },
        { h: "Necessary cookies", p: ["These cookies are required for the operation of the website and cannot be disabled."] },
        { h: "Optional cookies", p: ["With your consent, we use optional cookies to improve the website."] },
        { h: "Managing your settings", p: ["You can adjust your cookie consent at any time via the cookie notice or delete cookies in your browser."] },
      ],
    },
  },

  fr: {
    updatedLabel: "Dernière mise à jour : juillet 2025",
    order: ["impressum", "datenschutz", "agb", "einlagensicherung", "cookies"],
    labels: {
      impressum: "Mentions légales",
      datenschutz: "Confidentialité",
      agb: "CGV",
      einlagensicherung: "Garantie des dépôts",
      cookies: "Cookies",
    },
    impressum: {
      title: "Mentions légales",
      blocks: [
        { h: "Informations sur la société", p: ["Barlow Consultants SL", "Siège : Luxembourg", "Bureau Allemagne : Kurfürstendamm 30, 10719 Berlin, Allemagne"] },
        { h: "Registre du commerce", p: ["Enregistrée au Registro Mercantil de Murcia", "Numéro d'enregistrement : MU-114516"] },
        { h: "Gérant habilité", p: ["Francesco Vigna"] },
        { h: "Contact", p: ["Téléphone : +49 30 8268 8142", "E-mail : info@barlowconsultants.com"] },
        { h: "Responsable du contenu", p: ["Francesco Vigna, adresse ci-dessus."] },
        { h: "Responsabilité du contenu", p: ["Le contenu de ces pages a été élaboré avec le plus grand soin. Nous ne pouvons toutefois garantir l'exactitude, l'exhaustivité et l'actualité du contenu."] },
      ],
    },
    datenschutz: {
      title: "Politique de confidentialité",
      blocks: [
        { p: ["La protection de vos données personnelles nous tient à cœur. Nous vous informons ci-dessous du traitement de vos données conformément au Règlement général sur la protection des données (RGPD)."] },
        { h: "Responsable du traitement", p: ["Barlow Consultants SL, Luxembourg – bureau de Berlin, Kurfürstendamm 30, 10719 Berlin", "E-mail : info@barlowconsultants.com", "Contact protection des données : datenschutz@barlowconsultants.com"] },
        { h: "Données que nous traitons", list: ["Données de base (p. ex. nom)", "Données de contact (p. ex. adresse e-mail, téléphone)", "Données d'utilisation de votre espace client"] },
        { h: "Finalités du traitement", p: ["Nous traitons vos données pour fournir l'espace client, traiter les demandes et remplir des obligations contractuelles et légales."] },
        { h: "Bases légales", p: ["Le traitement est fondé sur l'art. 6, § 1 du RGPD (consentement, exécution d'un contrat et intérêt légitime)."] },
        { h: "Vos droits", list: ["Accès, rectification et effacement", "Limitation du traitement", "Portabilité des données", "Opposition et retrait du consentement", "Réclamation auprès d'une autorité de contrôle"] },
        { h: "Durée de conservation", p: ["Nous conservons les données personnelles uniquement le temps nécessaire aux finalités indiquées ou aux délais légaux de conservation."] },
      ],
    },
    agb: {
      title: "Conditions générales",
      blocks: [
        { h: "1. Champ d'application", p: ["Ces conditions générales s'appliquent à l'utilisation du site et des services de Barlow Consultants SL."] },
        { h: "2. Prestations", p: ["Barlow Consultants SL intermédie des placements à terme et propose du conseil patrimonial. Les conditions concrètes résultent du contrat individuel concerné."] },
        { h: "3. Compte & inscription", p: ["Une inscription est requise pour utiliser l'espace client. Vous êtes responsable de la confidentialité de vos identifiants."] },
        { h: "4. Conditions & rendement", p: ["Les taux indiqués s'appliquent à la durée choisie. Les rendements des stratégies de gestion de patrimoine sont des valeurs cibles et ne constituent pas une garantie."] },
        { h: "5. Frais", p: ["L'ouverture de compte, les dépôts et la tenue de compte sont gratuits. Aucun frais caché n'est appliqué."] },
        { h: "6. Responsabilité", p: ["Nous ne sommes responsables des dommages qu'en cas de faute intentionnelle et de négligence grave, dans les limites autorisées par la loi."] },
        { h: "7. Droit applicable", p: ["Le droit du Grand-Duché de Luxembourg s'applique, dans les limites autorisées par la loi."] },
      ],
    },
    einlagensicherung: {
      title: "Garantie des dépôts",
      blocks: [
        { p: ["Vos dépôts sont protégés deux fois : par la garantie légale européenne des dépôts et, en complément, par une conservation séparée sur un compte fiduciaire."] },
        { h: "Garantie légale des dépôts (FGDL)", p: ["Les fonds conservés relèvent du système légal de garantie des dépôts luxembourgeois (FGDL – Fonds de garantie des dépôts Luxembourg). Conformément à la directive UE 2014/49/UE, les dépôts sont protégés jusqu'à 100 000 € par déposant et par établissement."] },
        { h: "Conservation", p: ["Les fonds sont conservés auprès de Banking Circle S.A. au Luxembourg."] },
        { h: "Protection fiduciaire supplémentaire", p: ["En complément, les fonds des clients sont conservés sur un compte fiduciaire séparé – strictement distinct des actifs de Barlow Consultants SL."] },
      ],
    },
    cookies: {
      title: "Politique de cookies",
      blocks: [
        { p: ["Nous utilisons des cookies pour assurer le fonctionnement du site et améliorer votre expérience."] },
        { h: "Cookies nécessaires", p: ["Ces cookies sont indispensables au fonctionnement du site et ne peuvent pas être désactivés."] },
        { h: "Cookies optionnels", p: ["Avec votre consentement, nous utilisons des cookies optionnels pour améliorer le site."] },
        { h: "Gérer vos préférences", p: ["Vous pouvez ajuster votre consentement aux cookies à tout moment via la bannière de cookies ou supprimer les cookies dans votre navigateur."] },
      ],
    },
  },
};

export default legal;
